import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { IPaginationResponse } from '../../../../core';
import { notificationsData } from '../data';
import {
  IInboxNotificationResponse,
  IMarkAllNotificationsAsSeenResponse,
  IMyNotificationPaginationParameters,
  INotificationFilterParameters,
  IUnseenNotificationsCountResponse,
  INotificationLookupResponse
} from '../dtos';
import { IMyNotificationsApiClient } from './i-my-notifications-api.client';

@Injectable({
  providedIn: 'root'
})
export class MyNotificationsInMemoryApiClient implements IMyNotificationsApiClient {
  constructor(protected http: HttpClient) {}

  get(paginationParameters?: IMyNotificationPaginationParameters): Observable<IPaginationResponse<IInboxNotificationResponse>> {
    return of(notificationsData.inboxNotificationsResponse);
  }

  getById(id: string): Observable<IInboxNotificationResponse> {
    return of({ ...notificationsData.inboxNotificationResponse, isSeen: true, seenOnUtc: new Date().toISOString() });
  }

  getUnseenCount(filter?: INotificationFilterParameters): Observable<IUnseenNotificationsCountResponse> {
    return of(notificationsData.unseenNotificationsCountResponse);
  }

  markAsSeen(id: string): Observable<void> {
    return of(undefined);
  }

  markAllAsSeen(filter?: INotificationFilterParameters): Observable<IMarkAllNotificationsAsSeenResponse> {
    return of(notificationsData.markAllNotificationsAsSeenResponse);
  }

  getLookups(): Observable<INotificationLookupResponse> {
    return of(notificationsData.notificationLookupResponse);
  }
}
